import { ColumnFiltersState, SortingState, TableState, VisibilityState } from '@tanstack/react-table';
import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
import _ from 'lodash';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function padTableData(page: any[], pageIndex: number, pageSize: number, tableSize: number): any[] {
  const start = pageIndex * pageSize;
  const end = start + pageSize;

  const prev = Array.from({ length: start }, () => ({}));
  const next = Array.from({ length: tableSize - end }, () => ({}));

  return prev.concat(page).concat(next);
}

export function tomorrow() {
  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);
  tomorrow.setHours(0, 0, 0, 0);
  return tomorrow;
}

export function formatYyyyMmDd(date: Date) {
  return date.toLocaleDateString('en-CA');
}

export function createTableStateFromSearchParams(
  searchParams: Record<string, string | undefined>
): Partial<TableState> {
  const cleanedParams = _.omitBy(searchParams, value => value == null) as Record<string, string>;
  const params = new URLSearchParams(cleanedParams);

  const pageIndex = params.get('pageIndex');
  const pageSize = params.get('pageSize');

  return {
    sorting: params.get('sorts') as unknown as SortingState | undefined,
    columnFilters: params.get('filters') as unknown as ColumnFiltersState | undefined,
    columnVisibility: params.get('visibility') as unknown as VisibilityState | undefined,
    pagination: pageIndex && pageSize ? { pageIndex: Number(pageIndex), pageSize: Number(pageSize) } : undefined
  };
}
